module.exports = __webpack_public_path__ + "default-card-image-481f3cdbd8dc19f7a338.svg";